import { t } from '@lingui/core/macro';
import { type Point, type PointerEventObject } from 'highcharts';

import type { CompanyType } from '@/api/common';
import { useOfflineTimeline } from '@/api/offlineEvents';
import { type ChartCallbackFunction } from '@/components/Flare';
import { usePageFilterContext } from '@/components/page';
import { Panel } from '@/components/panels';
import NonDigitalEventsTimelineChart from '@/features/NonDigitalEventsTimeline/NonDigitalEventsTimelineChart';

type Props = {
  company?: CompanyType;
  marginLeft: number;
  marginRight: number;
  onHoverChart?: (event: PointerEventObject, point: Point) => void;
  onHoverLeaveChart?: (event: MouseEvent) => void;
  onPostRenderChart?: ChartCallbackFunction;
};

const CompanyDetailNonDigitalEventsChart = ({
  company,
  marginLeft,
  marginRight,
  onHoverChart,
  onHoverLeaveChart,
  onPostRenderChart,
}: Props) => {
  const {
    pageFilters: { startDate, endDate },
  } = usePageFilterContext();
  const { offlineTimeline, isLoading, error } = useOfflineTimeline(startDate, endDate, {
    companyId: company?.id,
  });

  return (
    <Panel title={t`Non-Digital Events`} verifyC99Tag noPadding>
      <NonDigitalEventsTimelineChart
        data={offlineTimeline}
        isLoading={isLoading || !company}
        error={error}
        marginLeft={marginLeft}
        marginRight={marginRight}
        onHoverChart={onHoverChart}
        onHoverLeaveChart={onHoverLeaveChart}
        onPostRenderChart={onPostRenderChart}
      />
    </Panel>
  );
};

export default CompanyDetailNonDigitalEventsChart;
